import {Component, EventEmitter, Output} from '@angular/core';
import {Overlayable} from "../../../../interfaces/overlayable";

@Component({
  selector: 'brt-ranking-list-overlay-footer',
  templateUrl: './ranking-list-overlay-footer.component.html',
  styleUrls: ['./ranking-list-overlay-footer.component.scss']
})
export class RankingListOverlayFooterComponent implements Overlayable{
  @Output('onClosed') onClosed = new EventEmitter<boolean>();

}
